module.exports = __webpack_public_path__ + "static/media/just-cut.ea290667.svg";